export default __webpack_public_path__ + "static/media/mama-logo-blue.e2d87a33.svg";